import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { TwoColumnLayout, FormContent } from '../PrebookingSharedComponents';
import { CardContainer, SectionTitle, Field, FieldLabel, FieldValue, FieldGroup } from './SummaryShared';
import i18n from '../../i18n';

const TwoFieldRow = styled.div`
  display: flex;
  gap: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const SummaryCustomerInfo = ({ formData }) => (
  <CardContainer>
    <TwoColumnLayout>
      <SectionTitle>{i18n('translation_order_customer_info')}</SectionTitle>
      <FormContent>
        <FieldGroup>
          <Field>
            <FieldLabel>{i18n('translation_order_customer_number')}</FieldLabel>
            <FieldValue>{formData.customerNumber || '-'}</FieldValue>
          </Field>
          <TwoFieldRow>
            <Field>
              <FieldLabel>{i18n('translation_order_ordered_by')}</FieldLabel>
              <FieldValue>{formData.orderMadeBy || '-'}</FieldValue>
            </Field>
            <Field>
              <FieldLabel>{i18n('translation_order_ordering_unit')}</FieldLabel>
              <FieldValue>{formData.orderingUnit || '-'}</FieldValue>
            </Field>
          </TwoFieldRow>
        </FieldGroup>
      </FormContent>
    </TwoColumnLayout>
  </CardContainer>
);

SummaryCustomerInfo.propTypes = {
  formData: PropTypes.object.isRequired,
};

export default SummaryCustomerInfo;
